import React from "react";
import Pie from "./pie";
import useExpenses from "../useExpenses";
import { SegmentedControl } from "@telegram-apps/telegram-ui";
import useBackButton from "../useBackButton";
import Table from "./Table";
import Bar from "./bar";
import { useSearchParams } from "react-router";
import BottomButtons from "../BottomButtons";

export default function Charts() {
  const [searchParams] = useSearchParams();
  const begin = searchParams.get("from");
  const end = searchParams.get("to");

  if (!begin || !end) {
    throw new Error("Invalid params");
  }

  const expenses = useExpenses(begin, end);

  const [chart, setChart] = React.useState<React.ReactNode | null>(null);

  const table = React.useMemo(() => <Table expenses={expenses} />, [expenses]);
  const pie = React.useMemo(() => <Pie expenses={expenses} />, [expenses]);
  const bar = React.useMemo(
    () => <Bar expenses={expenses} begin={begin} end={end} freq="daily" />,
    [expenses, begin, end]
  );

  const [selected, setSelected] = React.useState<number>(0);

  const charts = React.useMemo(() => [table, pie, bar], [table, pie, bar]);

  React.useEffect(() => {
    setChart(charts[selected]);
  }, [selected, charts]);

  useBackButton();

  // two charts as two rows, min height 500px
  return (
    <div>
      <div>{chart}</div>
      <BottomButtons>
        <SegmentedControl>
          <SegmentedControl.Item
            selected={selected === 0}
            onClick={() => setSelected(0)}
          >
            表
          </SegmentedControl.Item>
          <SegmentedControl.Item
            selected={selected === 1}
            onClick={() => setSelected(1)}
          >
            円
          </SegmentedControl.Item>
          <SegmentedControl.Item
            selected={selected === 2}
            onClick={() => setSelected(2)}
          >
            棒
          </SegmentedControl.Item>
        </SegmentedControl>
      </BottomButtons>
    </div>
  );
}
